var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass:
        "analyses-online-order-section d-flex flex-column ga-6 px-6 py-8 pa-sm-8 overflow-hidden",
      attrs: { "data-qa": "analyses_online_order_section" },
    },
    [
      _c("h2", { staticClass: "text-h6 text--text mb-0" }, [
        _vm._v("\n    Почему выбирают онлайн-заказ\n  "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column flex-sm-row ga-4 ga-sm-6 w-100 align-sm-stretch",
        },
        _vm._l(_vm.benefits, function (benefit) {
          return _c(_setup.AnalysesOnlineOrderBenefit, {
            key: benefit.number,
            attrs: {
              number: benefit.number,
              title: benefit.title,
              description: benefit.description,
              image: benefit.image,
              "illustration-modifier":
                benefit.number === 3 ? "wide" : "default",
              spaced: benefit.number === 2,
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }